import React from 'react';
import styled from 'styled-components';
import htmlParser from 'utils/html/htmlParser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mediaQueries } from 'styles/utils/mediaQueries';
import HotDealsSliderComponent from './components/hotDealsSlider/HotDealsSliderComponent';
import Departures from './components/departures/Departures';
import PriceComponent from './components/price/PriceComponent';

function DealCardComponent({ deal, pathToDealPage }) {
  return (
    <a href={`${pathToDealPage}/${deal.id}`} target={'_blank'} rel='noopener noreferrer'>
      <Root>
        <HotDealsSliderComponent images={deal.images} />
        <Content>
          <Name>{deal.name}</Name>
          <Description>{htmlParser(deal.shortDescription)}</Description>
          <HotelContent>
            {deal.hotels.map((hotel) => (
              <HotelName key={`hotel-${hotel.id}`}>
                <BedIcon icon='bed' />
                {hotel.name}
              </HotelName>
            ))}
          </HotelContent>
          <Departures departures={deal.departures} />
        </Content>
        <PriceComponent price={Math.min(...deal.departures.map(({ sellPrice }) => sellPrice))} />
      </Root>
    </a>
  );
}

export default DealCardComponent;

const Root = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-radius: 4px;
  border: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};
  cursor: pointer;

  &:hover {
    transform: translate3d(0, -1px, 0);
    box-shadow: 0 0 30px -6px rgba(0, 0, 0, 0.2);
  }

  ${mediaQueries.fromAndBelow.tablet`
    flex-direction: column;
  `}
`;

const Content = styled.div`
  flex: 1 0 auto;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px;
`;

const Name = styled.div`
  font-size: 2em;
  color: ${({ theme }) => `${theme.colors.links.default}`};
  font-weight: 700;
`;

const Description = styled.div`
  max-height: 42px;
  margin-top: 12px;
  overflow: hidden;
  font-size: 1.4em;

  p {
    ${mediaQueries.fromAndBelow.tablet`
    	max-width: 300px;	
		`};

    font-size: 1.5em;
    line-height: 20px;
    display: inline-block;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: normal;
    line-break: strict;
    hyphens: none;
    -webkit-hyphens: none;
    -moz-hyphens: none;
  }

  ${mediaQueries.fromAndBelow.tablet`
    max-width: 300px;	
    font-size: 1.5em;
	`};

  line-height: 20px;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
`;

const HotelContent = styled.div`
  display: flex;

  ${mediaQueries.below.tablet`
    flex-direction: column;
  `}
`;

const HotelName = styled.div`
  margin-top: 12px;
  margin-right: 12px;
  font-size: 1.4em;
  color: ${({ theme }) => `${theme.colors.text.light}`};
  font-weight: 700;
`;

const BedIcon = styled(FontAwesomeIcon)`
  margin-right: 12px;
`;
